export const GET_USER_DASHBOARD_PREFERENCES_REQUEST = "GET_USER_DASHBOARD_PREFERENCES_REQUEST";
export const GET_USER_DASHBOARD_PREFERENCES_FAILURE = "GET_USER_DASHBOARD_PREFERENCES_FAILURE";
export const GET_USER_DASHBOARD_PREFERENCES_SUCCESS = "GET_USER_DASHBOARD_PREFERENCES_SUCCESS";

export const GET_USER_DATA_REQUEST = "GET_USER_DATA_REQUEST";
export const GET_USER_DATA_FAILURE = "GET_USER_DATA_FAILURE";
export const GET_USER_DATA_SUCCESS = "GET_USER_DATA_SUCCESS";
export const ALTER_USER_24_HOUR_TIME_PREFERENCE = "ALTER_USER_24_HOUR_TIME_PREFERENCE";
export const ALTER_USER_TIME_PREFERENCE = "ALTER_USER_TIME_PREFERENCE";
